module.exports = __webpack_public_path__ + "img/share_care_pb.d3e34924.png";